import { createFileRoute } from "@tanstack/react-router";

import { NewsPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/news/$newsId")({
  component: OneNews,
});

function OneNews() {
  const { newsId } = Route.useParams();
  return <NewsPage key={newsId} newsId={newsId} />;
}
